import {useState,useEffect} from 'react'
import styled from 'styled-components'
import FeaturedCarousel from '../ui/FeaturedCarousel'
import { Link } from 'react-router-dom'
import { getAboutText , setAbout } from '../../api/firebase'
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2rem 3rem;
    min-height: 100vh; 

    article a{
        padding: 10px 20px;
        background-color: #eee;
        transition: all 0.3s ease-in;
        width: 100%;
        display: flex;
        text-align: center;
        text-decoration: none;
        justify-content: center;
        color: #333;
        transition: all 0.3s ease;
        font-size: 18px;
        &:hover{
            background-color: aquamarine;
            transform: scale(1.02);
            border-radius: 10px;
        }
    }
    #about{
        
        margin: 1rem 2rem;

    }

    h2{
        width: 100%;
        font-size: 2rem;
        margin-bottom: 10px;
    }
    h5 { 
        font-size: 18px;
        a{
            color: #2b5cff;
            text-decoration: none;
            transition: all 0.3s ease-in;
            &:hover{
                text-decoration: underline dotted;
            }
        }
    }
`


const Home = () => {

    const [ aboutText , setAboutText ] = useState("...")

    useEffect(()=>{
        async function fetchAbout(){
            const response = await getAboutText()
            console.log(response)
            setAboutText(response.text)
            
        }
        if(aboutText === "..."){
            fetchAbout()
        }
    },[aboutText])

  return (
    <Wrapper>
        <section>
            <header>
                <h2>About</h2>
            </header>
            <div id="hero"/>
            <article id="about">
                <p>{aboutText}</p>
                <Link to="/gallery">Check out my artwork!</Link>
            </article>
        </section>

        
    </Wrapper>
  )
}

export default Home